import * as yup from 'yup';

const CollectionTemplateSchema = yup.object({
  name: yup.string().required('Name is required'),
});

export { CollectionTemplateSchema };
